export default "__VITE_PUBLIC_ASSET__ed7d2a78__"